import React from "react";
import ImageThumbnail from "./ImageThumbnail";

export default function ReadyToUploadImages(props: {
  item: File;
  onRemove: (image: File) => void;
}): JSX.Element {
  let imgUrl = "";

  if (props.item instanceof File) {
    imgUrl = URL.createObjectURL(props.item);
  } else {
    imgUrl = "";
  }

  return (
    <ImageThumbnail
      imageUrl={imgUrl}
      imageFile={props.item as File}
      onRemove={() => props.onRemove(props.item as File)}
    />
  );
}
